<template>
  <div class="bs_sc_absolutely_anytime">
    <div class="d-sm-none d-block" v-b-visible="sizeExtraSmall"></div>
    <div class="d-none d-sm-block d-md-none" v-b-visible="sizeSmall"></div>
    <div class="d-none d-md-block d-lg-none" v-b-visible="sizeMedium"></div>
    <div class="d-none d-lg-block d-xl-none" v-b-visible="sizeLarge"></div>
    <div class="d-none d-xl-block" v-b-visible="sizeExtraLarge"></div>
  </div>
</template>

<script>
export default {
  name: "BootstrapSizeChecker",
  methods: {
    sizeExtraSmall(visible) {
      if (visible) {
        this.size("xs");
      }
    },
    sizeSmall(visible) {
      if (visible) {
        this.size("sm");
      }
    },
    sizeMedium(visible) {
      if (visible) {
        this.size("md");
      }
    },
    sizeLarge(visible) {
      if (visible) {
        this.size("lg");
      }
    },
    sizeExtraLarge(visible) {
      if (visible) {
        this.size("xl");
      }
    },
    size(bsSize) {
      this.$emit("bs-size-changed", bsSize);
    }
  }
};
</script>

<style scoped>
.bs_sc_absolutely_anytime {
  position: fixed;
  top: 0;
  bottom: 0;
}
</style>
